import { Vue, Component } from 'vue-property-decorator';
import { FaqCategoryData } from '@/types';
import { toI18n } from '@/utils/commonUtils';

@Component
export default class FaqCategory extends Vue {
  public faqCategoryData: FaqCategoryData[] = [
    { value: '', label: this.toI18n('BOARD_FAQ_ALL') }, // 전체
    { value: 'MEMBER', label: this.toI18n('BOARD_FAQ_MEMBER') }, // 회원
    { value: 'PRODUCT', label: this.toI18n('BOARD_FAQ_PRODUCT') }, // 상품
    { value: 'DELIVERY', label: this.toI18n('BOARD_FAQ_DELIVERY') }, // 배송
    { value: 'ORDER', label: this.toI18n('BOARD_FAQ_ORDER') } // 주문
  ];

  public getFaqCategory(faqCategory: string): string {
    return (
      this.faqCategoryData.find((category: FaqCategoryData): {} => {
        return category.value === faqCategory;
      }) || { value: '', label: this.toI18n('BOARD_FAQ_ALL') }
    ).label; // 전체
  }

  public toI18n(needToI18nStr: string): string {
    return toI18n(this.$t(needToI18nStr));
  }
}